/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
// import { PageHeader } from 'antd'
import { PageHeader } from '@ant-design/pro-layout'
import { Link } from 'react-router-dom'

const Content = ({content, extraContent}) => (
  <div style={{ display: 'flex'}}>
    <div>{content}</div>
    <div style={{ textAlign: 'right' }}>{extraContent}</div>
  </div>
)
class PageHeaderPage extends React.Component {
  static propTypes = {
    title: PropTypes.string, //
    breadcrumbList: PropTypes.array, // demo breadcrumbList=[{ breadcrumbName: 'XX', route: url}]
    extra: PropTypes.node, // 右上角功能键
    content: PropTypes.node,
    extraContent: PropTypes.node,
    /** 为 true 时外层不铺白底（如世界指挥中心深色 HUD），避免菜单下出现一条白条 */
    embedTransparent: PropTypes.bool,
  }
  static defaultProps = {
    breadcrumbList: []
  }
  handleItemRender = (route, params, routes, paths) => {
    return route.href
      ? <Link to={`${route.href}`}>{route.breadcrumbName}</Link>
      : <span>{route.breadcrumbName}</span>
  }
  render () {
    const { content, breadcrumbList, extraContent, embedTransparent, ...rest } = this.props
    return (
      <div
        style={{
          backgroundColor: embedTransparent ? 'transparent' : '#ffffff',
        }}
      >
        <PageHeader
          {...rest}
          breadcrumb={{
            routes: breadcrumbList.filter(item => item.breadcrumbName),
            itemRender: this.handleItemRender
          }}
        >
          <Content
            content={content}
            extraContent={extraContent}
          />
        </PageHeader>  
      </div>
    )
  }
}

export default PageHeaderPage
